import { render, staticRenderFns } from "./AfterSaleList.vue?vue&type=template&id=2632aad1"
import script from "./AfterSaleList.vue?vue&type=script&lang=js"
export * from "./AfterSaleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports